import type { GuideLang } from "@/lib/virtualspace/guide/guide-public-shape";

/** Public guide URLs; the language rides along as ?lang=ar. */
export function guideHref(path: string, lang: GuideLang): string {
  if (lang !== "ar") return path;
  const [base, hash] = path.split("#");
  const joined = `${base}${base.includes("?") ? "&" : "?"}lang=ar`;
  return hash ? `${joined}#${hash}` : joined;
}

export function otherLang(lang: GuideLang): GuideLang {
  return lang === "ar" ? "en" : "ar";
}

/** The same page in the other language, keeping every other query parameter and the hash (pure). */
export function languageSwitchHref(current: string, to: GuideLang): string {
  const [pathAndQuery, hash] = current.split("#");
  const [path, query = ""] = pathAndQuery.split("?");
  const params = new URLSearchParams(query);
  if (to === "ar") params.set("lang", "ar");
  else params.delete("lang");
  const q = params.toString();
  return `${path}${q ? `?${q}` : ""}${hash ? `#${hash}` : ""}`;
}
